export const DATIQ_INPUT_SEPERATOR: string = '__';
export const datiqInputCreateId: (parts: string[]) => string = (
    parts: string[]
) =>
    parts.reduce((currentId: string, part: string, index: number) =>
        index === 0 ? part : `${currentId}${DATIQ_INPUT_SEPERATOR}${part}`
    );
export const DATIQ_TRIGGER: string = 'trigger';
export const DATIQ_ITEM: string = 'item';
export const DATIQ_INPUT_AUTOCOMPLETE: string = 'autocomplete';
export const DATIQ_INPUT_CHIP: string = 'chip';
export const DATIQ_INPUT_SELECT: string = 'select';
export const DATIQ_INPUT_OPTION: string = 'option';
export const DATIQ_SELECT_OPTION: string = datiqInputCreateId([
    DATIQ_INPUT_SELECT,
    DATIQ_INPUT_OPTION,
]);
export const DATIQ_INPUT_SELECT_PILL: string = 'select-pill';
export const DATIQ_MENU: string = 'menu';
export const DATIQ_MENU_TRIGGER: string = datiqInputCreateId([
    DATIQ_MENU,
    DATIQ_TRIGGER,
]);
export const DATIQ_MENU_ITEM: string = datiqInputCreateId([
    DATIQ_MENU,
    DATIQ_ITEM,
]);
export const DATIQ_INPUT: string = 'input';
export const DATIQ_INPUT_SEARCH: string = 'search';
export const DATIQ_INPUT_CHECKBOX: string = 'checkbox';
export const DATIQ_INPUT_BUTTON: string = 'button';
export const DATIQ_INPUT_MODAL: string = 'modal';
export const DATIQ_INPUT_CAROUSEL: string = 'carousel';
export const DATIQ_INPUT_SLIDE: string = 'slide';
export const DATIQ_INPUT_RADIO: string = 'radio';
export const DATIQ_INPUT_TOGGLE: string = 'toggle';
export const DATIQ_INPUT_TOGGLE_BUTTON: string = 'toggle-button';
export const DATIQ_INPUT_SLIDER = 'slider';
export const DATIQ_INPUT_SLIDER_RANGE = 'slider-range';

export const DATIQ_ACTION_SAVE: string = 'save';
export const DATIQ_LINK: string = 'link';
export const DATIQ_SCREEN: string = 'screen';
export const DATIQ_TABS: string = 'tabs';

// * Add your access token to the endpoint here
export const DATIQ_ANALYTICS_GOOGLE_BEARER_TOKEN = ``;
export const DATIQ_ANALYTICS_TRACKING_PLAN_ROOT = `http://localhost:3333`;
export const DATIQ_ANALYTICS = 'Datiq Analytics';
export const DATIQ_ANALYTICS_TRACKING_VERSION = '0.2';

export const DATIQ_ANALYTICS_PLACEHOLDER_CURRENT_PAGE = '[CURRENT PAGE]';
